module.exports = __webpack_public_path__ + "img/Feature.e50683b8.png";